import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef, useCallback } from "react";
import { useFocusRing, useHover, mergeProps } from "react-aria";
import { CheckboxButton } from "./CheckboxButton.js";
import { useCheckboxInput } from "../hooks/useCheckboxInput.js";
import { useComponentClassName } from "../../../auxiliary/useComponentClassName.js";
import { toStateClass } from "../../../utils/toStateClass.js";
const Checkbox = memo(
  forwardRef(
    ({
      CheckboxButtonComponent,
      children: INTENTIONALLY_UNUSED_CHILDREN,
      max,
      min,
      onChange,
      value,
      ...outerProps
    }, forwardedRef) => {
      const componentClassName = useComponentClassName("checkbox");
      const notNull = outerProps.notNull;
      const onChangeRotateState = useCallback((next) => {
        if (!notNull) {
          if (value === false && next === true) {
            next = null;
          } else if (value === null) {
            next = true;
          }
        }
        onChange?.(next);
      }, [value, notNull, onChange]);
      const props = useCheckboxInput({
        ...outerProps,
        onChange: onChangeRotateState,
        defaultValue: outerProps.defaultValue,
        value
      }, forwardedRef);
      const { className, indeterminate, ...nativeInputProps } = props;
      const { isFocusVisible: focused, focusProps } = useFocusRing();
      const { isHovered: hovered, hoverProps } = useHover({ isDisabled: props.disabled });
      const ariaProps = {
        "aria-checked": props.indeterminate ? "mixed" : props.checked ? "true" : "false"
      };
      const CheckboxButton$1 = CheckboxButtonComponent ?? CheckboxButton;
      return /* @__PURE__ */ jsxs("div", { ...hoverProps, className: classNames(
        componentClassName,
        toStateClass("indeterminate", props.indeterminate),
        toStateClass("checked", props.checked),
        className
      ), children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "checkbox",
            ...mergeProps(
              nativeInputProps,
              ariaProps,
              focusProps
            ),
            className: `${componentClassName}-visually-hidden`
          }
        ),
        /* @__PURE__ */ jsx(
          CheckboxButton$1,
          {
            id: outerProps.id,
            placeholder: void 0,
            name: outerProps.name,
            active: outerProps.active,
            checked: props.checked,
            className,
            disabled: outerProps.disabled,
            distinction: outerProps.distinction,
            focused,
            hovered,
            indeterminate: props.indeterminate,
            intent: outerProps.intent,
            loading: outerProps.loading,
            readOnly: outerProps.readOnly,
            required: outerProps.required,
            scheme: outerProps.scheme,
            size: outerProps.size,
            validationState: outerProps.validationState
          }
        )
      ] });
    }
  )
);
Checkbox.displayName = "Checkbox";
export {
  Checkbox
};
//# sourceMappingURL=Checkbox.js.map
